module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/pencils5-transparent-UK.png"),
      "width": _vm.width,
      "height": _vm.height
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2118c5ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Logo.vue
// module id = 387
// module chunks = 2